import { basePath } from 'api/kinerja/penilik-pegawai/config'

import type {
  PerencanaanFilterState,
  PelaksanaanFilterState,
} from 'types/kinerja-tim-penilai-penilik'

export const queryKeyBaseName = 'tim-penilai-penilik'

export const apiPaths = {
  basePath,
  summary: (periodeId: string) => `${basePath}/${periodeId}/evaluator/summary`,

  // Perencanaan
  perencanaanListSummary: (periodeId: string) =>
    `${basePath}/perencanaan/${periodeId}/approval/filter`,
  perencanaanList: (periodeId: string, filter: PerencanaanFilterState) =>
    `${basePath}/perencanaan/${periodeId}/approval/skp/${filter}`,
  perencanaanDetail: (id: string) => `${basePath}/perencanaan/skp/${id}`,
  approvalSend: `${basePath}/perencanaan/approval/kirim`,
  approvalRevision: `${basePath}/perencanaan/approval/arahkan-revisi`,
  approvalApprove: `${basePath}/perencanaan/approval/setujui`,

  // Pelaksanaan
  pelaksanaan: `${basePath}/pelaksanaan`,
  pelaksanaanListFilter: (periodeId: string) =>
    `${apiPaths.pelaksanaan}/${periodeId}/filter`,
  pelaksanaanList: (periodeId: string, filter: PelaksanaanFilterState) =>
    `${apiPaths.pelaksanaan}/${periodeId}/skp/${filter}`,
  pelaksanaanSummary: (skpId) => `${apiPaths.pelaksanaan}/skp/${skpId}/summary`,
  pelaksanaanTugas: (skpId: string) =>
    `${apiPaths.pelaksanaan}/pelaksanaan-tugas/${skpId}`,
} as const

export const queryKeys = {
  API_GET_SUMMARY: `${queryKeyBaseName}-summary`,

  // Perencanaan
  API_GET_LIST_PERENCANAAN_PENILIK: `${queryKeyBaseName}-perencanaan-penilik-list`,
  API_GET_LIST_SUMMARY_PERENCANAAN_PENILIK: `${queryKeyBaseName}-perencanaan-penilik-list-summary`,
  API_GET_PERENCANAAN_PENILIK_DETAIL: `${queryKeyBaseName}-perencanaan-approval-detail`,

  // Pelaksanaan
  API_GET_PELAKSANAAN_PERILAKU_KERJA_TK: `${queryKeyBaseName}-pelaksanaan-ps-perilaku-kerja-tk`,
  API_GET_PELAKSANAAN_PERILAKU_KERJA_TK_OPTIONS: `${queryKeyBaseName}-pelaksanaan-ps-perilaku-kerja-tk-options`,
  API_GET_PELAKSANAAN_LIST_SUMMARY: `${queryKeyBaseName}-penilai-ps-pelaksanaan-list-summary`,
  API_GET_PELAKSANAAN_LIST: `${queryKeyBaseName}-penilai-ps-pelaksanaan-list`,
  API_GET_PELAKSANAAN_SUMMARY: `${queryKeyBaseName}-penilai-ps-pelaksanaan-summary`,
  API_GET_PELAKSANAAN_PRAKTIK_KINERJA_HASIL_SURVEY_KS: `${queryKeyBaseName}-penilai-ps-pelaksanaan-hasil-survey-ks`,
  API_GET_DOKUMEN_AKUNTABILITAS: `${queryKeyBaseName}-penilai-ps-pelaksanaan-dokumen-akuntabilitas`,
}
